/**
 * Simulates button-like keyboard behavior for Enter and Space keys.
 * Triggers the provided callback or simulates a click event on the target element.
 *
 * @param callback - Function to call when Enter or Space is pressed
 * @returns Keyboard event handler function
 */
const simulateButtonKeyboardBehavior = callback => {
  return e => {
    // Allow activation with Enter or Space keys
    if (e.key === "Enter" || e.key === " " || e.code === "Space") {
      e.preventDefault(); // Prevent scrolling with space key
      if (callback) {
        callback(e);
      } else {
        // Simulate a click event if no callback is provided
        e.target.click();
      }
    }
  };
};

export { simulateButtonKeyboardBehavior };
